import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { SCREEN_SM_MIN, SCREEN_XS_MAX } from 'constants/breakpointSizes';

class InvokerFunctionAlyaNormas extends PureComponent {
  static propTypes = {
    typeRel: PropTypes.string,
    onMount: PropTypes.func,
    getRefByType: PropTypes.func,
  };

  componentDidMount() {
    const { onMount, getRefByType, typeRel } = this.props;

    onMount(getRefByType(typeRel));
  }

  render() {
    return null;
  }
}

export default class RefSwitcher extends PureComponent {
  static propTypes = {
    getRefByType: PropTypes.func,
    onDidMount: PropTypes.func,
  };

  render() {
    const { onDidMount, getRefByType } = this.props;

    return (
      <Fragment>
        <MediaQuery query={SCREEN_XS_MAX}>
          <InvokerFunctionAlyaNormas
            getRefByType={getRefByType}
            typeRel="mobile"
            onMount={onDidMount}
          />
        </MediaQuery>

        <MediaQuery query={SCREEN_SM_MIN}>
          <InvokerFunctionAlyaNormas
            getRefByType={getRefByType}
            typeRel="desktop"
            onMount={onDidMount}
          />
        </MediaQuery>
      </Fragment>
    );
  }
}
